import React, { useEffect, useState } from 'react'
import EnterIcon from '../../assets/Enter_Arrow_Right.svg'
import UpdatePopover from '../common/popover/updatePopover'
import { formatDetectionDatetime } from '../../utilities/datetime'
import './GridView.scss'
import '../../components/common/grid/grid.scss'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { loadScreenshotResized } from '../../store/entities/superFeedEvents'
import { withRouter } from 'react-router-dom';
import Tooltip from '../common/popover/tooltip';
import { eventTypes } from '../../utilities/eventTypes'

const MARKED_SS_SUFFIX = '_marked';
const RESIZED_SS_SUFFIX = '_resized';
const TYPE_IMG = 'i';
const TYPE_HTML = 'h';

const GridView = (props) => {
    const {
        // pageNo,
        // pageSize,
        events,
        totalSize,
        // threatFilters,
        screenshotLoading,
        screenShots
    } = props

//   const { offset } = threatFilters


//   const [resultsArr, setResultsArr] = useState([offset + 20])
    
  const screenshotPlaceholder = `${process.env.REACT_APP_EXTERNAL_PAGES_BASE_URL}/placeholders/screenshot.jpeg`;
  

    useEffect(() => {
        fetchScreenshotsForEvents(events);
    }, [events])

    const onDetails = (item) => {
            props.history.push(`/super-feed/${item.eventId}`);
    };

    const fetchScreenshotsForEvents = (events) => {
        const customers = props.customerList || [];
        const { screenShots, loadScreenshotResized, isLastPage } = props;
        events.forEach(event => {
            // Only fetch if not already loaded
            //get containername from customerlist

            const container = customers.find(c => c.id === event.customerId)?.blobContainer || '';
            if (!screenShots || !screenShots[event.eventId]) {
                loadScreenshotResized(container, [event.customerId, event.extensionInstallId],
                `${event.eventId}${event.type === eventTypes.reported_phish? "" : RESIZED_SS_SUFFIX}`,
                TYPE_IMG,
                event.eventId
            );
            }
        });
    }

   return (
    <div className="d-flex flex-column pageContainer">
        <div style={{ minWidth: '290px' }}>
            <b>
            Results ({(props.isLastPage ? totalSize : `More than ${totalSize}`) || 0})
            </b>
        </div>
        <div className="d-flex flex-column grid-container mt-3" style={{ width: '95%' }}>
            <div className={'grid-body'} >
                <div className="grid-card d-inline-flex flex-wrap" style={{ padding: '16px' }}>
                    <Row style={{ marginLeft: '0px', width: '1276px' }}>
                        {events.map((record, index) => (
                            <Col
                                xs="6"
                                sm="6"
                                md="6"
                                lg="6"
                                xl="6"
                                style={{ padding: '0px', marginBottom: ' 16px' }}
                                key={index}
                            >
                            <div
                            key={record.eventId}
                            className="super-feed-grid-item"
                            style={{ marginRight: '0px'}}
                            >
                            <div className="d-flex mb-2 align-items-center">
                                {<span className={`mr-auto ${props.getStatusClass(record.status)}`}>
                                    <b>{record.status}</b> 
                                </span>}
                                <div
                                className="grid-text font-weight-normal"
                                style={{ marginRight: '0.2rem' }}
                                >
                                <UpdatePopover {... props} role="PixmAdmin" event={record} from="superFeedGrid" />
                                </div>
                            </div>
                            <div
                                key={record.eventId}
                                className="image-container mb-2"
                                style={{
                                lineHeight: '150px',
                                textAlign: 'center',
                                }}
                            >
                                {(screenshotLoading[record.eventId] === true) ? <div className='loader'></div> :
                                    (<img  
                                    src={screenShots[record.eventId] || screenshotPlaceholder}
                                    style={{
                                    borderRadius: '5px',
                                    maxWidth: '582px',
                                    maxHeight: '254px',
                                    }}
                                    alt=""
                                    srcSet=""
                                />) 
                            }
                                
                            </div>

                            <div>
                                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                                <tbody>
                                    <tr style={{ background: 'white' }}>
                                    <td width="70%">
                                        <div
                                        className=""
                                        title={record.url}
                                        style={{ width: '95%' }}
                                        >
                                        <b>{props.getCustomerName(record.customerId)}</b>
                                        </div>
                                    </td>                            
                                    </tr>
                                    <tr style={{ background: 'white' }}>
                                    <td >
                                        <div
                                            className="textWrap"
                                            title={record.url}
                                            style={{ width: '95%' }}
                                            data-tip data-for={record.url}
                                        > 
                                            {record.url} 
                                        </div>
                                        <Tooltip id={record.url} data={record.url} />
                                    </td>
                                    <td width="30%">
                                        <div
                                        style={{ width: '95%', color: 'rgb(45, 95, 167)' }}
                                        title={record.detectedBrands || 'NA'}
                                        className="textWrap"
                                        >
                                        <b>{record.detectedBrands || 'NA'}</b>
                                        </div>
                                    </td>
                                    </tr>
                                    <tr>
                                    <td >
                                        <div
                                        style={{ width: '95%' }}
                                        title={formatDetectionDatetime(record.detectedOn)}
                                        className="font-italic"
                                        >
                                        Opened at{' '}
                                        {formatDetectionDatetime(record.detectedOn)}
                                        </div>
                                    </td>
                                    <td width="5%" style={{ paddingLeft: '0px', textAlign: 'right' }}>
                                        {' '}
                                        <img
                                        style={{ cursor: 'pointer', width: '30px' }}
                                        onClick={() => onDetails(record)}
                                        src={EnterIcon}
                                        alt="next-icon"
                                        />
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                            </div>
                        </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
    // events: state.entities.superFeedEvents.list,
    screenShots: state.entities.superFeedEvents.screenshots,
    screenshotLoading: state.entities.superFeedEvents.screenshotsLoading,
    isLastPage: state.entities.superFeedEvents.isLastPage,
    superFeedEventsLoading: state.entities.superFeedEvents.eventsLoading,
    displaySize: state.entities.superFeedEvents.displaySize,
    // threatFilters: state.entities.events.threat.filters,
    customerList : state.entities.customers.list,

});

const mapDispatchToProps = (dispatch) => ({
    loadScreenshotResized: (container, filepath, blobName, type, eventId) => dispatch(loadScreenshotResized(container, filepath, blobName, type, eventId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GridView));